import { HomeRoomSectionNameFragment } from "../../../Utilities";
import * as HomeRoomFormat from "../HomeRoom";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: HomeRoomSectionNameFragment) {
	return `${Fields.namePrefix(instance.namePrefix)}${HomeRoomFormat.name(instance.homeRoom)}${Fields.nameSuffix(
		instance.nameSuffix,
	)}`;
}

/**
 * Returns the abbreviated name of the given instance. (Used for icons).
 */
export function abbreviatedName(instance: HomeRoomSectionNameFragment) {
	return `${Fields.namePrefix(instance.namePrefix).trim()}${HomeRoomFormat.abbreviatedName(
		instance.homeRoom,
	)}${Fields.nameSuffix(instance.nameSuffix).trim()}`;
}
